import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { provideConfig } from '@spartacus/core';
import { PaginationConfig } from '@spartacus/storefront';
import { CustomPaginationComponent } from './custom-pagination.component';



@NgModule({
  providers: [
    provideConfig(<PaginationConfig>{
      pagination: {
        rangeCount: 5,
        addDots: true,
        addPrevious: true,
        addNext: true,
        addFirst: true,
        addLast: true,
        addStart: false,
        addEnd: false,
        dotsLabel: "...",
        previousLabel: '<',
        nextLabel: '>',
        substituteDotsForSingularPage: false
      }
    })],
  declarations: [CustomPaginationComponent],
  imports: [
    CommonModule, RouterModule
  ],
  exports: [CustomPaginationComponent]
})
export class CustomPaginationModule { }
